<template>

    <div class="row">
        <h2 class="text-center w-100 sucesso">
            <strong>Sucesso!</strong><br />

        </h2>
        <div class="col-md-12 text-center">
            <span class=" mt-3 text-azul-escuro">
                Seu cadastro foi finalizado, estamos te redicionando para o seu acesso, aguarde...
            </span>
        </div>

        <div class="col-md-12 text-center mt-3">
            <button type="button" class="btn btn-primary rounded-pill px-4" @click="redirecionar()">Redirecionar</button>
        </div>
    </div>


</template>



<script>
    import { Api } from '@/common/api'
    import Global from '@/common/global'

    export default {
        name: 'cadastro-finalizar',
        data: () => ({

        }),
        methods: {
            redirecionar() {
                window.location = Global.URL_SHOPPING_CNA;
            },
        },

        mounted() {
            setTimeout(() => {
                this.redirecionar();
            }, 3000)
        }
    };
</script>
